export const availableEnvironments = {
  dev: 'Development',
  prod: '',
  local: 'Local',
  qa: 'QA',
}
